import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const postQueryMessage = async ({ queryId, message, closed }) => {
  const token = localStorage.getItem("token");

  const payload = {
    query_id: queryId,
    text: message,
    closed: closed,
  };

  await axios.post(`${__API_URL__}/api/ecrf/generate_messages/`, payload, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });
};

const useGenerateMessageMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postQueryMessage,
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ["query_change_logs"] });
    },
  });
};

export default useGenerateMessageMutation;
